<template>
  <div class="detail">
    <div class="swipe">
      <div class="back-button"><van-icon name="arrow-left" color="#fff" size="16px" @click.stop="back"/></div>
      <van-swipe @change="onChange">
        <van-swipe-item v-for="image in swipes">
          <img :src="image" style="width: 100%"/>
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">{{ currentImgIndex + 1 }}/ {{ swipes.length }}</div>
        </template>
      </van-swipe>
    </div>
    <div class="item main-info">
      <div class="price">
        <span style="font-size: 15px;color: #ff931f;margin-right: 3px;font-weight: 600;">￥</span>
        <span style="font-size: 23px;color: #ff931f;font-weight: 600;">{{price}}</span>
        <span style="font-size: 12px;color: #C6C6C6;margin-left: 3px;">/人起</span>
      </div>
      <div class="title">
        {{title}}
      </div>
      <div class="serv-desc" @click="serviceVisible = true;">
        <img src="./img/transport.png">
        <span>飞机/高铁免费接送</span>
        <img src="./img/gropu.png">
        <span>满14人成团</span>
        <van-icon name="arrow" color="#828282"/>
      </div>
    </div>
    <van-popup
        v-model:show="serviceVisible"
        closeable
        round
        position="bottom"
        :style="{ maxHeight: '70%', minHeight: '50%' }"
    >
      <div class="title">服务说明</div>
      <div class="content">
        <img src="./img/transport.png">
        <div class="small-title">免费接送飞机和高铁</div>
        <div class="detail-desc" style="margin-left: 30px;">
          如您到达昆明的方式是通过飞机或高铁，我们将为您提供免费接送机服务。接送人员将于出行日前一天致电为您安排接送服务，请留意来电。
        </div>
        <img src="./img/gropu.png">
        <div class="small-title">满14人成团</div>
        <div class="detail-desc" style="margin-left: 30px;">
          基于保险公司对直付理赔服务的理赔操作规范，保险公司将于每月底将对本月产生的直付理赔款进行理赔。订单未跨月且在出行日3天前，可联系{{ getServicePhoneText() }}进行退款，不产生费用；订单跨月或在出行日3日内的不支持退款，但可联系{{ getServicePhoneText() }}进行改期。
        </div>
      </div>
    </van-popup>
    <div class="item order-step">
      <div class="tag">
        预定流程
      </div>
      <div @click="stepVisible = true;">
        <div class="icons">
          <img src="./img/pay.png">
          <div class="line"></div>
          <img src="./img/wait.png">
          <div class="line"></div>
          <img src="./img/ticket.png">
          <div class="line"></div>
          <img src="./img/enjoy.png">
        </div>
        <div class="text">
          <span>拍下付款</span>
          <span>等待成团</span>
          <span>购票出行</span>
          <span>享受康养</span>
        </div>
      </div>
    </div>
    <van-popup
        v-model:show="stepVisible"
        closeable
        round
        position="bottom"
        :style="{ maxHeight: '90%', minHeight: '50%' }"
    >
      <div class="title">预定流程</div>
      <div class="content">
        <div v-for="step in orderStep">
          <div class="small-title">{{ step.title }}</div>
          <div class="detail-desc">{{ step.content }}</div>
        </div>
      </div>
    </van-popup>
    <div class="item trip-features">
      <div class="tag">
        行程特色
      </div>
      <div class="content" id="featuresContent">
        <img src="./img/1.jpg">
        <img src="./img/2.jpg">
        <img src="./img/3.jpg">
        <img src="./img/4.jpg">
        <img src="./img/5.jpg">
        <img src="./img/6.jpg">
        <img src="./img/7.jpg">
        <img src="./img/8.jpg">
        <img src="./img/9.jpg">
        <img src="./img/10.jpg">
        <img src="./img/11.jpg">
        <img src="./img/12.jpg">
        <img src="./img/13.jpg">
        <img src="./img/14.jpg">
        <img src="./img/15.jpg">
      </div>
      <div class="collapse" @click="foldTripFeatures">
        {{!foldFeatures ? '展开全部' : '点击收起'}}
        <van-icon :name="!foldFeatures ? 'arrow-down' : 'arrow-up'" />
      </div>
    </div>
    <div class="item trip-arrange">
      <div class="tag">
        行程安排
      </div>
      <div class="arrange-content" id="arrangeContent">
        <div class="one-arrange" v-for="arrange in arrangeInfo">
          <div class="left">
            <div class="day-number">
              <span class="day">Day</span>
              <span class="number">{{ arrange.day }}</span>
            </div>
            <div class="bar"></div>
          </div>
          <div class="right">
            <div class="title">{{ arrange.place }}</div>
            <ol>
              <li v-for="detail in arrange.arranges">{{ detail }}</li>
            </ol>
            <div class="card" v-for="place in arrange.mainPlaces" @click="showCardDetail(place)">
              <img :src="place.img">
              <div class="middle">
                <div class="title">{{ place.name }}</div>
                <div class="labels">
                  <span class="label" v-for="label in place.labels">{{ label }}</span>
                </div>
              </div>
              <div class="arrow"><van-icon name="arrow" color="#ff931f" size="20px"/></div>
            </div>
          </div>
        </div>
      </div>
      <div class="collapse" @click="foldTripArrange">
        {{!foldArrange ? '展开全部' : '点击收起'}}
        <van-icon :name="!foldArrange ? 'arrow-down' : 'arrow-up'" />
      </div>
    </div>
    <van-popup
        v-model:show="descVisibel"
        closeable
        round
        position="bottom"
        :style="{ height: '80%' }"
    >
      <div class="title">{{ placeInfo.title }}</div>
      <div class="content">
        <div style="color: #393939;font-size: 14px;margin-bottom: 10px;" v-for="info in placeInfo.content">
          {{ info }}
        </div>
        <img :src="img" style="display: block;width: 100%;height: auto;" v-for="img in placeInfo.img">

      </div>
    </van-popup>
    <div class="item cost">
      <div class="tag">
        费用包含
      </div>
      <vant-table :option="costIncludesOption" :table-data="costIncludesData" style="padding: 12.5px 12.5px 11px"></vant-table>
      <div class="tag">
        费用自理
      </div>
      <vant-table :option="costExpectOption" :table-data="costExpectData" style="padding: 12.5px 12.5px 23.5px"></vant-table>
    </div>
    <div class="item order-desc">
      <div class="tag" style="padding-bottom: 14.5px">
        预定说明
      </div>
      <div class="desc-item" v-for="desc in orderDesc">
        <div class="title">{{ desc.title }}</div>
        <div class="content">{{ desc.content }}</div>
      </div>
    </div>
    <div class="item policy">
      <div class="tag">
        退改政策
      </div>
      <div class="policy-detail">
        <p class="paragraph" v-for="policy in policyDetail">
          {{ policy }}
        </p>
      </div>
    </div>
    <div class="footer">
      <a class="customer-service" :href="getServicePhoneTel()">
        <img src="./img/customer-service.png">
        <div class="txt" style="color: #222222">
          联系客服
        </div>
      </a>
      <div class="order-button">
        <van-button type="primary" size="large" round color="#FF931F" @click="toSelectTime">立即预约</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import VantTable from "./components/vant-table";
import { getServicePhoneText, getServicePhoneTel } from '@/utils/common';
export default {
  name: "detail",
  components: {VantTable},
  data() {
    return {
      currentImgIndex: 0,
      price: 6000,
      title: '(昆明本地团)云南康养之旅-康享云巅 6天5晚 康养之旅(不含来回昆明费用)',
      foldFeatures: false,
      foldArrange: false,
      swipes: [
        require('./img/主图.jpg'),
        require('./img/swipe (1).jpg'),
        require('./img/swipe (2).jpg'),
        require('./img/swipe (3).jpg'),
        require('./img/swipe (4).jpg'),
        require('./img/swipe (5).jpg'),
        require('./img/swipe (6).jpg'),
        require('./img/swipe (7).jpg'),
        require('./img/swipe (8).jpg'),
      ],
      costIncludesOption: {
        column: [
          {
            prop: 'itemName',
            width: 'width:22%;text-align:center;font-weight:bold;'
          },
          {
            prop: 'description',
            width: 'width:78%;text-align:left;'
          },
        ]
      },
      costIncludesData: [
        {
          itemName: '住宿',
          description :'全程 5 晚指定酒店，全程不提供自然单间'
        },
        {
          itemName: '用餐',
          description :'5 早餐 8 正餐+雪山营养餐包，餐标 40 元/人；特色餐 50 元/人，早餐均为酒 店自助餐。（核桃宴+白族 BBQ 烧烤+丽江三文鱼+养生黑山羊+养生晚宴+养生过桥米线）'
        },
        {
          itemName: '用车',
          description :'使用车辆正规、合法旅游运营资质空调车辆，整车 10%空率'
        },
        {
          itemName: '服务',
          description :'行程中所安排导游为持有国家导游资格证且从业经验丰富的优秀导游'
        },
        {
          itemName: '安全',
          description :'旅行社为游客购买云南旅游组合保险（旅行社责任险+旅游意外伤害险）'
        },
        {
          itemName: '门票',
          description :'含景点首道门票，包含石林景区、大理古城、丽江古城、玉龙雪山门票+大索 道往返、蓝月谷门票'
        },
        {
          itemName: '特别体验',
          description :'《印象丽江》、石林电瓶车、敞篷吉普车、皮划艇'
        },
      ],
      costExpectOption: {
        column: [
          {
            prop: 'itemName',
            width: 'width:22%;text-align:center;font-weight:bold;'
          },
          {
            prop: 'description',
            width: 'width:78%;text-align:left;'
          },
        ]
      },
      costExpectData: [
        {
          itemName: '交通',
          description :'不含所在城市到昆明机场/车站的往返交通费用'
        },
        {
          itemName: '产品升级',
          description :'升级舱位、升级酒店、升级房型等产生的差价'
        },
        {
          itemName: '自费项目',
          description :'行程中注明需要另行支付的自费景点'
        },
        {
          itemName: '补充',
          description :'人力不可抗拒因素或因交通延误、取消等意外事件所引起的额外费用，酒店内个人消费'
        },
        {
          itemName: '其它项目',
          description :'自由行程期间交通费、餐费、等私人费用'
        },
      ],
      serviceVisible: false,
      stepVisible: false,
      descVisibel: false,
      arrangeInfo: [
        {
          day: '01',
          place: '昆明',
          arranges: ['行程：全国各地自行出发—到昆明—商务车送达酒店—滋养温泉疗愈','交通：自行购票到昆明，若您落地昆明高铁站长水机场，将为您提供免费接送','餐饮：因抵达时间不一，全日不含餐','入住：亿壕城堡温德姆至尊酒店（温泉酒店）'],
          mainPlaces: [
            {
              img: require('./img/温姆入口.png'),
              name: '亿壕城堡温德姆至尊酒店（温泉酒店）',
              labels: ['特色泡池','棋牌室'],
              detail: ['非凡之旅：昆明亿壕城堡温德姆至尊酒店，是中国区域第28家温德姆至尊酒店，是春城地区仅有的温德姆至尊品牌酒店。是集客房、餐饮、会议、婚宴、康养为一体的欧陆式高端奢华城堡酒店。总建筑面积45000㎡。华美浮雕，重彩油画， 绒布地毯在璀璨的水晶吊灯映衬下，营造出古欧中世纪特 有的古堡风情。',
                  '非凡体验：欧陆式城堡风情的客房，配套智能化灯光系统，另有免费无线网络、开通了国际卫星频道的液晶电视等完备设施，给您倍感舒适的入住体验！',
                  '完美演绎：16个多功能厅布局灵活多样，配备现代化视听及多媒体设备，满足不同规模的会议需求。更有2000㎡的罗曼草坪婚礼广场及900㎡的莫奈屋顶花园，独具欧陆风情，为您打“造梦中婚礼”。国际水准的一站式会议统筹服务为您定制卓越的会议享受！品逸真温泉：酒店具有得天独厚的地热资源及天然的富锶泉水。还有户外无边际泳池，溶洞泡池等30多个功能特色泡池，更有5栋家庭汤屋。品逸纯粹，养乐一体，一站式满足您的纯享体验。'],
              detailImg: [require('./img/温姆1_1.png'),require('./img/温姆2_1.png'),require('./img/温姆3_1.png')]
            }
          ]
        },
        {
          day: '02',
          place: '昆明/楚雄/大理',
          arranges: ['行程：参加疗养项目(微运动康复筋络拉伸操)—游览石林风景区—普洱茶品鉴—民族特色茶灸—住大理','餐饮：早餐（酒店自助餐）、中餐（团队餐）、晚餐（核桃宴）','入住：大理地热国酒店'],
          mainPlaces: [
            {
              img: require('./img/石林入口.jpg'),
              name: '石林风景区',
              labels: ['天下第一奇观','喀斯特地貌'],
              detail: [
                  '石林景区位于昆明石林县，是昆明的必游景点之一。石林是典型的喀斯特特色地貌，石峰、石芽、落水洞、地下河遍布，峰林幻化成各种形态，剑状、塔状、蘑菇状等等，千奇百怪美轮美奂。',
                  '石林景区的几大片区分布较为疏散，以大小石林景区为中心，乃古石林位于大小石林景区以北约12公里处，大叠水景区位于大小石林景区西南约29公里处，长湖景区则位于大小石林景区东南方26公里处。常规的游玩石林多指大小石林。',
                  '大小石林位于同一区域，大门口购票进去后，沿着甬道前行20分钟，左手边即是规模较小、石峰略为平缓的小石林景区，在一片茂密的峰丛中，有名的阿诗玛石即屹立在此，巍峨的峰林幻化成一位亭亭玉立的彝族姑娘阿诗玛，仿佛正在向你招手，这里是游人喜爱的合影之地。除了俊俏的阿诗玛，小石林区还有神骏、簇石擎天等景观，无不形态各异。这可是考验想象力的时候，如果你的想象力不够丰富，建议请一位导游，在他的引导下，你会对眼前的峰林有全新的认识。',
                  '沿着公路缓缓前行，路边依次是唐僧石、石监狱、凤凰梳翅、灵芝石等，无不栩栩如生，惟妙惟肖，以各种姿态向你展示着大自然的造化奇功。',
                  '沿着甬道前行，不经意间就来到大石林区，经过“双鸟渡食”“犀牛望月”“莲花峰”“石林胜境”“石屏风”等奇景，也走的有点累了吧，在狮子亭稍作休息，欣赏对面狮子池的峰林倒影，也不失为一种宁静的享受。看多了峰林，难免会有一些审美疲劳。是时候看看水景啦。乘上石林湖的游船，泛舟湖上，山光水色集于一处，所有的压力苦恼全都消失了。',
                  '如果不想走路这么累，景区内有彝族姑娘开着电瓶车在景区间穿梭，招手即停。也一样可以饱览石林奇观，遇到热心的女司机，还会讲解一点小典故。',
                  '乃古石林位于大小石林以北13公里处，也叫新石林或摩寨石林，石林景观、白云湖、石峰山、幽谷仙瀑组成。与大小石林相比，这里又是另外一种风格。这里的峰林整体呈灰黑色，石柱高大密集，有城堡状、塔状、蘑菇状等，古朴粗犷的怪石如浪涛般冲天而起，气势磅礴，漫步黑色的峰林中，仿佛进入荒蛮世界。'
              ],
              detailImg: [require('./img/石林1_1.jpg'),require('./img/石林2_1.jpg'),require('./img/石林3_1.jpg'),require('./img/石林4_1.jpg')]
            },
            {
              img: require('./img/地热国入口.jpg'),
              name: '大理地热国酒店',
              labels: ['天然硫磺温泉','日光浴'],
              detail: [
                  '大理地热国酒店位于洱源大理市洱源县茈碧湖镇大理地热国，近茈碧湖，是到大理苍山、洱海、丽江古城、玉龙雪山和迪庆香格里拉的必经之地。',
                  '这里占地1000亩，总投资3.47亿人民币，是以温泉沐浴文化为特色的休闲度假型旅游风景区。',
                  '洱源县地热国现有各类客房，其布局多为典型的白族庭院格局，整体建筑艺术吸收了西方及江南民宅的优点，土木砖石结构，粉白灰墙，局部会以水墨山水画，更显典雅大方。',
                  '室内配有私人的温泉沐浴池。休闲娱乐设施近在咫尺，钓鱼观赏的小河从窗下流过，其幽雅的环境和全方位的服务可以使游客完全放松。'
              ],
              detailImg: [require('./img/地热国1_1.png'),require('./img/地热国2_1.png'),require('./img/地热国3_1.png'),require('./img/地热国4_1.png')]
            }
          ]
        },
        {
          day: '03',
          place: '大理',
          arranges: ['行程：游览大理古城—体验敞篷吉普车—参加疗养项目(健康步道、中医呼吸吐纳讲习)— 体验皮划艇—花海美拍—白族BBQ 烧烤—音乐疗愈—参加花海落日派对— 住大理','餐饮：早餐（酒店自助餐）、中餐（团队餐）、晚餐（白族BBQ烧烤）','入住：大理国际大酒店'],
          mainPlaces: [
            {
              img: require('./img/大理入口.jpg'),
              name: '大理古城',
              labels: ['文艺慢生活','古时大理国都城'],
              detail: [
                  '大理古城位于风光秀丽的苍山脚下，是古代南诏国和大理国的都城。这里是个适合生活的地方，当地人日出而作日落而息，闲时养花草晒太阳，加之阳光明媚温度适宜，吸引游客无数。',
                  '白天必逛：在古城，白天你可以逛逛复兴路，复兴路是古城的一条步行街，街两边有众多店铺，经营大理石雕刻、民族服饰和当地特色食品等当地特产。在各色店铺间穿行流连，可以淘些有民族特色的小东西，累了饿了，路边的小吃店也能吃到有特色的当地小吃。',
                  '古城夜生活：夜间，你可以像混在当地的人们一样，聚集在洋人街和人民路一带，这里有超多的特色酒吧和小咖啡馆，有些店里还有驻场歌手或者游人的即兴演出，热闹非凡。你尽可以在酒杯和音乐间寻觅那一份属于你的活色生香。'
              ],
              detailImg: [require('./img/大理1.jpg'), require('./img/大理2.jpg')]
            },
            {
              img: require('./img/洱海入口.jpg'),
              name: '洱海生态廊',
              labels: ['自然风光','蔚蓝胡泊'],
              detail: [
                  '洱海生态廊道是一条人与湖的界限，通过物理相隔，给洱海“透透气”。将沿岸各村连接在一起，使各具特色的白族传统村落成为“围绕洱海的一串珍珠”沿着生态廊道缓缓步行，一副乡愁画卷正徐徐展开。'
              ],
              detailImg: [require('./img/洱海1_1.jpg'),require('./img/洱海2_1.jpg')]
            },
            {
              img: require('./img/大理国际入口.png'),
              name: '大理国际大酒店',
              labels: ['迷人海景','景观泳池'],
              detail: [
                  '酒店取舍于繁华与幽静之地，悠闲在传统与自然之间，静卧在龙山遗风的注脚下，俯可瞰270度洱海的壮阔全景，远可眺苍山白雪银顶的秀丽雄奇，与洱海公园、龙山公园相拥，是一方颐养心灵的理想之所。',
                  '酒店内一步一景，或民族，或现代，或时尚，或雅致，美景流动，漫步其间，愉悦随心弥散，是集山水园林生活为主题和白族特色文化于一体的奢华商务休闲度假酒店。',
                  '酒店拥有多间全景客房，设有迎曦楼、白渊和白源楼三栋楼，房型按所在楼层命名。所有房间都覆盖高速无线网络，配备JBL多功能蓝牙音响、胶囊咖啡机、高清液晶电视，以及智能客控服务系统，套房更配备观景阳台和天文望远镜。中、西、法三个特色餐厅和2个大堂酒廊带来独具地域文化的美食之旅，缔造令人难忘的绝妙味蕾体验。特色红酒吧、雪茄吧、私人影院和蓝逸SPA将为旅途注入更多尊崇体验。同时，室内外泳池、儿童俱乐部、健身中心等休闲娱乐设施一应俱全。会议中心拥有一个1095㎡的多功能宴会厅和5个会议室，是商务会议和婚宴的不二之选。',
                  '“大梦境 理想源”——置身本酒店，在苍山洱海间，享风花雪月之惬意，感大理奢尚生活真谛。'
              ],
              detailImg: [require('./img/大理国际1.png'),require('./img/大理国际2.png'),require('./img/大理国际3.png')]
            },
          ]
        },
        {
          day: '04',
          place: '大理/丽江',
          arranges: ['行程：参观民族特色体验馆—游览玉龙雪山—参加疗养项目(为运动康复-经络拉伸操)—观赏印象丽江(特殊情况安排丽水金沙)—搭乘冰川大索(旺季限票时可能改小索道)—游览蓝月谷—享用三文鱼— 游览丽江古城四方街—住丽江','餐饮：早餐（酒店自助餐）、中餐（雪山营养餐包）、晚餐（丽江三文鱼）','入住：丽江金林豪生大酒店'],
          mainPlaces: [
            {
              img: require('./img/雪山入口.jpg'),
              name: '玉龙雪山',
              labels: ['高山草甸','海拔冰川'],
              detail: [
                  '玉龙雪山是丽江知名景点之一，也是纳西族心中的神山，一共13座山峰连绵起伏，似银龙飞舞，因此得名。景区内可以直接乘坐索道上山，轻松欣赏高海拔冰川的瑰丽，是很多游客来此游玩的亮点。',
                  '雪山概述：玉龙雪山以"险、奇、美、秀"著称。从山脚到山顶，有亚热带、温带、寒带等多级景观逐级。山脚的甘海子，是一片辽阔的牧场，春夏之际，草甸上龙胆兰、杜鹃盛放，在这里远望，玉龙群峰历历在目。海拔3200多米的云杉坪，更是纳西青年男女心中的圣地。这里是一片幽静的草甸，四周古木参天藤萝密布，环境幽静。玉龙十三峰下有19条现代海洋性冰川，远望如一片瀑布悬挂于扇子陡下方，在阳光的照耀下，泛着银光。游人可乘坐大索道抵达4506米的高度后，沿着山间栈道近距离观赏冰川和主峰的雄姿。',
                  '大索道：景区受欢迎的索道，将游人从位于甘海子的索道下站运送到海拔4506米的冰川公园。下了索道，沿着冰川上铺设的木质栈道，可一直行进到海拔4680米的最高处，近距离感受雪山和冰川的魅力。如遇大风天气，可能会停运，具体请留意官方消息。',
                  '云杉坪索道：索道下站位于雪山脚下白水河畔，乘坐景区环保巴士可达。乘坐云杉坪索道可抵达海拔3240米的云杉坪，这里是远观玉龙雪山群峰的好位置。',
                  '牦牛坪索道：牦牛坪是位于玉龙雪山另一侧面的一块大草坪，距离云杉坪约15公里。登上牦牛坪，可以从另一角度观赏玉龙雪山。'
              ],
              detailImg: [require('./img/雪山1_1.jpg'),require('./img/雪山2_1.jpg'),require('./img/雪山3_1.jpg'),require('./img/雪山4_1.jpg')]
            },
            {
              img: require('./img/印象丽江入口.jpg'),
              name: '印象丽江',
              labels: ['张艺谋导演','实景歌舞表演'],
              detail: [
                  '《印象丽江》是张艺谋导演的“印象系列”之一。演出以雪山为背景、以民俗文化为主题、以当地原住民为演员，在海拔3100米的玉龙雪山甘海子蓝月谷剧场露天舞台，真实的展示出原住民对天、地、人、山的感情。',
                  '《印象丽江》分“雪山篇”和“古城篇”两篇，包含《古道马帮》、《对酒雪山》、《天上人间》、《打跳组歌》、《鼓舞祭天》和《祈福仪式》六个部分。“雪山篇”描述的是与山的对话，表现的是人们从四面八方来到丽江，体验生命与自然的紧密关系；“古城篇”讲述的是与祖先的对话，在对话中发现：古往今来在人们的内心深处，始终存在一个神圣的王国。参与演出的500多名演员均来自当地周边的农村，以粗犷的气势、原生的姿态和质朴的歌声，带给观众很真实的丽江印象。'
              ],
              detailImg: [require('./img/印象丽江1_1.jpg'),require('./img/印象丽江2_1.jpg'),require('./img/印象丽江3_1.jpg')]
            },
            {
              img: require('./img/丽江入口.jpg'),
              name: '丽江古城',
              labels: ['水乡山城','城市漫步'],
              detail: [
                  '丽江古城又名大研镇，是茶马古道上有名的城镇之一，影视剧《一米阳光》、《木府风云》等都在此取过景。古城内木楼青瓦，古街石巷，小桥流水，站在古城东大街上，举头即可遥望玉龙雪山，景色十分秀丽。',
                  '丽江古城依山而建，街巷依水流而设，曾经是茶马古道的交易市场。古城内从四方街延伸出光义街、七一街、五一街和新华街四条主干道，四条路又衍生出纵横交错的街巷，构成了以四方街为中心的古城。当年被徐霞客盛赞的木土司王府木府，就位于七一街关门口附近，在这里可以感受纳西民族建筑的内涵。',
                  '玉河水在城中一分为三，三分成九，再分成无数条水渠，形成主街傍河、小巷临渠的局面，使得古城充满生机。',
                  '古城里遍布经营各地特产的店铺，有民族饰品、茶叶、银器、披肩等。此外，这里有众多餐馆，无论是本地风味，还是西餐披萨，一切都能让你大饱口福。'
              ],
              detailImg: [require('./img/丽江1_1.jpg'),require('./img/丽江2_1.jpg'),require('./img/丽江3_1.jpg'),require('./img/丽江4_1.jpg')]
            },
            {
              img: require('./img/金林豪生入口图.jpg'),
              name: '丽江金林豪生大酒店',
              labels: ['中式园林','儿童乐园'],
              detail: [
                  '丽江金林豪生大酒店坐落于丽江中轴线上，束河古镇和大研古城之间**通往玉龙雪山的主干道旁，地理位置优越，交通便利，依山傍水，环境优雅，钟敏毓秀。',
                  '酒店拥有共有四百余间温馨舒适的客房，颇具特色的花园和雪山景观更让宾客的异地之旅更加舒适放松。'
              ],
              detailImg: [require('./img/金林豪生1.jpg'),require('./img/金林豪生2.jpg'),]
            },
          ]
        },
        {
          day: '05',
          place: '大理/昆明',
          arranges: ['行程：参加疗养项目(八段锦养生操)—参观云南特色体验馆—享用黑山羊宴—乘动车返回昆明—享用养生晚宴—参加音乐疗愈—住昆明','餐饮：早餐（酒店自助餐）、中餐（丽江特色黑羊山宴）、晚餐（养生晚宴）','入住：昆明昊邦主屋健康管理中心'],
        },
        {
          day: '06',
          place: '昆明/回程',
          arranges: ['行程：进行综合体检—参加疗养项目(养生茶灸)—品尝云南养生过桥米线—参观网红花卉交易中心—机场/高铁站送行—自行返程','餐饮：早餐（酒店自助餐）、中餐（过桥米线）'],
        },
      ],
      orderDesc: [
        {
          title: '拍下付款',
          content: '支持使用普康宝支付，普康宝额度不足的情况下可使用微信支付补全订单金额。支付成功后扣减普康宝额度。'
        },
        {
          title: '等待成团',
          content: '每个精品团最少14人，最多20人。达到14人后自动成团，成团成功后将以短信的形式通知到联系人。出行日前10天还未达14人视为成团失败。'
        },
        {
          title: '购票出行',
          content: '在收到成团短信后，请自行购买来回昆明的票，出行日出发前往指定酒店入住集合。'
        },
        {
          title: '享受康养',
          content: '我们将安排专车带您安全抵达酒店，旅行全程有专人为您服务。'
        },
      ],
      orderStep: [
        {
          title: '拍下付款',
          content: '支持使用普康宝支付，普康宝额度不足的情况下可使用微信支付补全订单金额。支付成功后扣减普康宝额度。'
        },
        {
          title: '等待成团',
          content: '每个精品团最少14人，最多20人。达到14人后自动成团，成团成功后将以短信的形式通知到联系人。出行日前10天还未达14人视为成团失败。'
        },
        {
          title: '购票出行',
          content: '在收到成团短信后，请自行购买来回昆明的票，出行日出发前往指定酒店入住集合。'
        },
        {
          title: '享受康养',
          content: '我们将安排专车带您安全抵达酒店，旅行全程有专人为您服务。'
        },
      ],
      placeInfo: {
        title: '',
        content: [],
        img: '',
      },
      policyDetail: [
          '1.买家违约：订单生效后，因买家原因取消订单的，费用(违约金)扣除标准如下:',
          '成团后-行程开始日3天：20%',
          '行程开始当日 100% ',
          '',
          '2.商家违约：组团成功后，因商家原因取消订单的，且买家已支付来回路途费用的，商家应向买家赔偿相应损失，并协调最近可出游日期。',
          '',
          '政策说明: ',
          '1、订单生效的规定以平台规则的相关规定为准。',
          '2、以上扣除标准提及的“日”指自然日',
          '3、如发生商家已尽合理注意义务但仍不能避免的客观事件或不可抗力因素，导致商家取消订单的不属于商家原因。反之，买家亦然。'
      ]
    }
  },
  methods: {
    getServicePhoneText,
    getServicePhoneTel,
    onChange(index) {
      this.currentImgIndex = index;
    },
    foldTripFeatures() {
      this.foldFeatures = !this.foldFeatures;
      let tripFeaturesHeight = document.getElementById("featuresContent");
      if (this.foldFeatures == false) {
        tripFeaturesHeight.style.height = 162 + "px";
      } else {
        tripFeaturesHeight.style.height = "auto";
      }
    },
    foldTripArrange() {
      this.foldArrange = !this.foldArrange;
      let tripArrangeHeight = document.getElementById("arrangeContent");
      if (this.foldArrange == false) {
        tripArrangeHeight.style.height = 560 + "px";
      } else {
        tripArrangeHeight.style.height = "auto";
      }
    },
    toSelectTime() {
      this.$router.push({
        name: 'SelectTime',
        /*params: {
          // info: this.$route.params.info
        }*/
      })
    },
    back() {
      this.$router.back();
    },
    showCardDetail(place) {
      if (place.detail) {
        this.descVisibel = true;
        this.placeInfo = {
          title: place.name,
          content: place.detail,
          img: place.detailImg,
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.detail {
  img {
    -webkit-touch-callout: none;
    //pointer-events: none;
  }
  .swipe {
    position: relative;
    .back-button {
      position: absolute;
      top: 56px;
      left: 15px;
      width: 33px;
      height: 33px;
      border-radius: 17px;
      overflow: hidden;
      background-color: #222222;
      opacity: .6;
      line-height: 33px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
    }
    .van-swipe-item {
      width: 375px;
    }
    .custom-indicator {
      position: absolute;
      right: 9px;
      bottom: 9px;
      padding: 4.5px 17px;
      font-size: 12px;
      color: #FFFFFF;
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.6);
    }
  }
  .item {
    margin: 13.5px 12px 0;
    border-radius: 8px;
    background-color: #fff;
    color: #222222;
    .tag {
      font-size: 18px;
      color: #222;
      font-weight: bold;
      padding: 15px 0 0 12.5px;
    }
    .collapse {
      color: #ff931f;
      text-align: center;
      background-color: #fff;
      height: 43px;
      line-height: 43px;
    }
  }
  .main-info {
    padding: 12.5px 15px 18px 20px;
    .title {
      font-size: 18px;
      font-weight: 600;
      padding: 15px 0;
    }
    .serv-desc {
      font-size: 12px;
      color: #828282;
      img {
        width: 15px;
        height: 15px;
        vertical-align: middle;
        margin-right: 7px;
      }
      span {
        display: inline-block;
        margin-right: 15px;
        vertical-align: middle;
      }
      .van-icon-arrow {
        float: right;
        vertical-align: middle;
        line-height: 16px;
      }
    }
  }
  .order-step {
    padding-bottom: 20px;
    .icons {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 24px;
      img {
        width: 18px;
        height: 18px;
      }
      .line {
        width: 50px;
        height: 1px;
        background-color: #FFC98F;
        margin: 0 7px;
      }
    }
    .text {
      font-size: 12px;
      display: flex;
      justify-content: center;
      margin-top: 12px;
      span {
        margin-right: 34px;
      }
      span:last-child {
        margin-right: 0;
      }
    }
  }
  .trip-features {
    overflow: hidden;
    .content {
      padding: 13px 15.5px 3.5px;
      overflow: hidden;
      height: 162px;
      transition: height 1.5s ease;
      img {
        width: 100%;
        vertical-align: middle;
      }
    }
  }
  .trip-arrange {
    overflow: hidden;
    position: relative;
    .arrange-content {
      width: 100%;
      height: 560px;
      transition: height 1.5s ease;
      margin-top: 32px;
      margin-bottom: 50px;
      .one-arrange {
        width: 100%;
        display: flex;
        margin-top: 15px;
        .left {
          display: inline-block;
          width: 77px;
          .day-number {
            width: 77px;
            height: 30px;
            color: #FFFFFF;
            background: linear-gradient(-135deg, transparent 3px, #ff931f 0);
            line-height: 30px;
            .day {
              font-size: 16px;
              margin-left: 13px;
              margin-right: 6px;
            }
            .number {
              font-size: 19px;
              font-weight: bold;
            }
          }
          .bar {
            margin-left: 76px;
            width: 1px;
            height: calc(100% - 30px);
            background-color: #E9E9E9;
          }
        }
        .right {
          display: inline-block;
          padding: 0 15px;
          width: calc(100% - 105px);
          .title {
            color: #222222;
            font-size: 18px;
            font-weight: bold;
          }
          ol {
            list-style-type: none;
            color: #393939;
            font-size: 14px;
            margin-top: 10px;
            li{
              line-height: 21px;
            }
          }
          .card:first-child {
            margin-top: 20px;
            margin-bottom: 0;
          }
          .card {
            box-sizing: border-box;
            width: 100%;
            margin-top: 15px;
            border-radius: 4px;
            overflow: hidden;
            display: flex;
            background-color: #fff;
            box-shadow: 0px 0px 10px #ccc;
            padding: 6px;
            img {
              width: 78px;
              height: 60px;
              border-radius: 4px;
              overflow: hidden;
            }
            .middle {
              width: calc(100% - 100px);
              margin-left: 9px;
              .title {
                margin-left: 0;
                display: inline-block;
                font-size: 15px;
                white-space: nowrap;
                width: 100%;
                overflow: hidden;
                text-overflow:ellipsis;
              }
              .labels {
                margin-top: 10px;
                display: inline-block;
                font-size: 12px;
                width: 100%;
                height: 24px;
                line-height: 18px;
                overflow: hidden;
                .label {
                  display: inline-block;
                  padding: 2px;
                  border: 1px solid #ff931f;
                  border-radius: 2px;
                }
                .label:first-child {
                  margin-right: 5px;
                }
              }
            }
            .arrow {
              width: 20px;
              display: flex;
              align-items: center;
              justify-content: right;
            }
          }
        }
      }
    }
    .collapse {
      position: absolute;
      bottom: 0;
      width: 100%;
      color: #ff931f;
      text-align: center;
      background-color: #fff;
      height: 43px;
      line-height: 43px;
    }
  }
  .order-desc {
    .desc-item {
      padding: 0 12.5px 19.5px;
      .title {
        font-size: 16px;
        margin-bottom: 8px;
        font-weight: bold;
      }
      .content {
        font-size: 14px;
      }
    }
  }
  .policy {
    margin-bottom: 113.5px;
    .policy-detail {
      padding: 13px 12.5px 24px;
      .paragraph {
        font-size: 14px;
        margin: 0;
      }
      .paragraph:nth-child(3) {
        margin-bottom: 12px !important;
      }
      .paragraph:nth-child(5) {
        margin-bottom: 12px !important;
      }
    }
  }
  .footer {
    width: 100%;
    height: 80px;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    .customer-service {
      text-align: center;
      padding: 14.5px 0 6px 20px;
      img {
        width: 19px;
        height: 17px;
      }
      font-size: 10px;
      float: left;
    }
    .order-button {
      float: right;
      padding: 9px 15px 20px;
      width: 70%;
    }
  }
  .van-popup {
    color: #222222;
    overflow: hidden;
    .title {
      font-size: 18px;
      padding: 15px 40px 15px 12px;
      text-align: center;
      background-color: #fff;
      border-radius: 16px 16px 0 0;
      position: fixed;
      width: calc(100% - 30px);
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow:ellipsis;
    }
    .content {
      overflow: auto;
      height: calc(100% - 110px);
      padding: 0 15px;
      margin-top: 60px;
      margin-bottom: 50px;
      img {
        width: 21px;
        height: 21px;
        margin-right: 10px;
        vertical-align: middle;
      }
      .small-title {
        display: inline-block;
        font-size: 16px;
        font-weight: bold;
        vertical-align: middle;
      }
      .detail-desc {
        color: #393939;
        font-size: 14px;
        margin-top: 14px;
        margin-bottom: 22px;
      }
    }
  }
}

</style>